
import axios from 'axios';
import { LLMWNLIResponse } from '../../types/llm';

export const getWNLIResults = async (
  sentence1: string,
  sentence2: string
) => {
  return await axios
    .post<LLMWNLIResponse>(
      `${process.env.REACT_APP_BACKEND_URL}/llm/wnli`,
      {
        sentence1: sentence1,
        sentence2: sentence2,
      }
    )
    .then((response) => {
      return response.data;
    });
};
